import { Button, Card, CardContent, Chip, CircularProgress, Container, CssBaseline, Grid, IconButton, Link as LinkA, ListItemIcon, Menu, MenuItem, Pagination, Typography } from "@mui/material";
import { withStyles } from "@mui/styles";
import clsx from 'clsx';
import { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import HeaderMenu from "src/components/header-menu";
import { Styles } from "src/styles/material-styles";
import SearchBar from "../called-list/components/search-bar";
import Api from "src/services/api";
import moment, { now } from "moment";
import * as calledsActions from '../../redux/actions/calleds';
import * as headerMenuActions from '../../redux/actions/header-menu';
import * as userSessionActions from '../../redux/actions/user-session';
import * as lastCalledsQueueActions from '../../redux/actions/last-calleds-queue'
import { AbilityContext } from '../../config/ability-context'
import { Overlay } from "src/styles/global";
import CustomizedSnackbars from "src/components/material-snackbars";
import { PapiroConsole } from "src/utils/papiroConsole";
import FirstElement from "src/components/first-element";
import { Add, CallMade, Email, ExitToApp, MoreVert, QueuePlayNext } from "@mui/icons-material";
import Footer from "src/components/footer";
import { searchById } from "src/services/called.service";
import CalledCard from "../general-search/components/calleds-card";
import TreeDots from 'src/components/tree-dots';
import VideoCallIcon from '@mui/icons-material/VideoCall';
import { Link, useLocation } from 'react-router-dom';
import fileDownload from "js-file-download";
import ApiReports from "src/services/apireport";

class CalledsArchived extends Component {
    constructor(props) {

        super(props)

        const { userSession, intl } = this.props

        if (userSession == null || userSession.user == null || userSession.user.userrole == null) {
            Api.logoff();
        }

        this.userOrganizations = userSession.user.userorganizations;

        this.isClient = true
        this.isAdm = false
        this.isTechnical = false
        this.admGlobal = false
        this.isAdmOrg = false
        this.isCoordenator = false

        userSession.user.userrole.map((item, key) => {
            if (item.role.roletype != 3) {
                this.isClient = false;
            }
            if (item.role.roletype == 2) {
                this.isTechnical = true;
            }
            if (item.role.roletype == 0 || item.role.roletype == 1 || item.role.roletype == 4) {
                this.isAdm = true;
            }
            if (item.role.roletype == 1)
                this.isAdmOrg = true;
            if (item.role.roletype == 4)
                this.isCoordenator = true;
            if (item.role.roletype == 0) {
                this.admGlobal = true;
            }
        })

        let filters = [
            { name: intl.formatMessage({ id: "id" }), id: "id" },
            { name: intl.formatMessage({ id: "title" }), id: "title" },
            { name: intl.formatMessage({ id: "requestuser" }), id: "requestuser" },
            //{ name: intl.formatMessage({ id: "assigned" }), id: "assigneduser" },
        ]

        if (!this.isClient) {
            filters.push(
                { name: 'E-mail do solicitante', id: "requestusermail" },
                { name: intl.formatMessage({ id: "request.user.document" }), id: "requestuserdocument" },
            )
        }

        this.orderFieldList = [
            {
                name: "id",
                displayName: "ID",
            },
            {
                name: "openingdate",
                displayName: intl.formatMessage({ id: "creation.date" }),
            },
            {
                name: "duedate",
                displayName: intl.formatMessage({ id: "estimated.solution.date" }),
            }
        ]

        this.canStartCallCenter = false;
        userSession.user.organizationusers.map((item) => {
            if (item.organization.organizationsettings) {
                if (item.organization.organizationsettings.allowscreateanonymouscalledsbyemail) {
                    this.isCheckEmail = true;
                }
                if (item.organization.organizationsettings.canstartcallcenter) {
                    this.canStartCallCenter = true;
                }
            }
        });

        if (this.admGlobal == true && this.isClient == false) {
            this.isCheckEmail = true;
            this.canStartCallCenter = true;
        }
        const now = new Date()

        this.state = {
            calleds: [],
            count: 0,
            totalPages: 0,
            page: 1,
            pageStart: 0,
            pageEnd: 0,
            searchValue: '',
            filterSelected: 0,
            filters: filters,
            orderFields: this.orderFieldList,
            dateStart: new Date(now.getFullYear(), now.getMonth(), 1),
            dateEnd: new Date(now.getFullYear(), now.getMonth() + 1, 0),
            dateOptions: [
                { id: 1, name: 'Data de abertura' },
                { id: 2, name: 'Data da solução' }
            ],
            dateOptionSelected: { id: 1, name: 'Data de abertura' },
            contentFilter: '',
            contentOrder: '',

            loading: false,
            openNotification: false,
            notificationVariant: "error",
            notificationMessage: "",

            itemsTree: [],
            filterMenuAnchorEl: null,
            checkMailAndVideoCallInsert: false,
        }

        this.orderTwoActions = [
            "id", "title", "open", "duedate"
        ]

        this.handleChangeFieldValue = this.handleChangeFieldValue.bind(this)
        this.handleChangeValue = this.handleChangeValue.bind(this)
        this.addFilter = this.addFilter.bind(this)
        this.clearFields = this.clearFields.bind(this)
        this.clearFilters = this.clearFilters.bind(this)
        this.callSearch = this.callSearch.bind(this)
        this.closeNotification = this.closeNotification.bind(this)
        this.setPagination = this.setPagination.bind(this)
        this.goToCalled = this.goToCalled.bind(this)
        this.openCanAssignCalledDialog = this.openCanAssignCalledDialog.bind(this)
        this.consultCalled = this.consultCalled.bind(this)
        this.setNotification = this.setNotification.bind(this)
        this.setLoading = this.setLoading.bind(this)
        this.handleClickFilterMenu = this.handleClickFilterMenu.bind(this)
        this.handleCloseFilterMenu = this.handleCloseFilterMenu.bind(this)
        this.handleDelete = this.handleDelete.bind(this)
    }

    handleClickFilterMenu = (event) => {
        this.setState({ filterMenuAnchorEl: event.currentTarget })
    }

    handleCloseFilterMenu = _ => {
        this.setState({ filterMenuAnchorEl: null })
    }

    async componentDidMount() {
        const { intl, userSession } = this.props

        var userId = userSession && userSession.user && userSession.user.id
        if (this.props.location && this.props.location.state && this.props.location.state.origin) {

            this.getFiltersByFlagDisplayFilterInCalledListNew()
        } else {
            let sessionPage = localStorage.getItem('calledsPageArchivedCalleds')
            if (sessionPage == null) {
                sessionPage = 1
                localStorage.setItem('calledsPageArchivedCalleds', '1')
            }
            if (!isNaN(sessionPage) && typeof sessionPage === 'string')
                sessionPage = parseInt(sessionPage)

            await this.addFilterOnComponentDidMount(intl)
            this.setState({ page: sessionPage })

            if (this.canStartCallCenter && !this.isClient && !this.state.checkMailAndVideoCallInsert) {
                var itemCallCenter =
                    <Button
                        color="secondary"
                        size="large"
                        style={{ marginBottom: "5px" }}
                        onClick={this.videoCallClick}
                        startIcon={<VideoCallIcon />}
                        disabled={this.state.disabledvertex}
                    >
                        {intl.formatMessage({ id: "video.call" })}
                    </Button>
                if (this.state.itemsTree && !this.state.itemsTree.includes(itemCallCenter)) {
                    this.state.itemsTree.push(itemCallCenter);
                }
            }
            if (this.isCheckEmail && !this.isClient && !this.state.checkMailAndVideoCallInsert) {
                var itemEmail =
                    <Button
                        color="secondary"
                        size="large"
                        style={{ marginBottom: "5px" }}
                        onClick={this.openCheckEmail}
                        startIcon={<Email />}
                    >
                        {intl.formatMessage({ id: "check.email" })}
                    </Button>
                if (this.state.itemsTree && !this.state.itemsTree.includes(itemEmail)) {
                    this.state.itemsTree.push(itemEmail);
                }
            }
            this.setState({ checkMailAndVideoCallInsert: true })
        }
    }

    addFilterOnComponentDidMount = async (intl) => {

        let newFilter = localStorage.getItem('newFilterArchivedCalleds')
        let newSearch = localStorage.getItem('newSearchArchivedCalleds')

        if (newFilter != null && newFilter.length > 0 && newSearch != null && newSearch.length > 0) {

            await this.setState({ contentFilter: '' })
            var field = newFilter.split('|')
            var value = newSearch.split('|')
            if (field && field.length > 0 && value && value.length > 0) {
                for (let i = 0; i < field.length; i++) {
                    if (field[i].length > 0) {
                        let nameField = field[i]
                        let filterName = this.state.filters.filter(f => f.id === field[i])
                        if (filterName && filterName.length > 0)
                            nameField = filterName[0].name

                        if (nameField == "calledcards") {
                            nameField = intl.formatMessage({ id: "called.report.header" })
                        }
                        var contentFilterTest = '' + nameField + " = " + value[i] + "\n"
                        if (!(this.state.contentFilter.includes(contentFilterTest))) {
                            await this.setState({
                                contentFilter: this.state.contentFilter + nameField + " = " + value[i] + "\n"
                            });
                        }

                    }
                }
            }
        }
        let calledListPersistFilter = localStorage.getItem('calledListPersistFilterArchivedCalleds')
        if (calledListPersistFilter && calledListPersistFilter == 'true') {
            localStorage.setItem('calledListPersistFilterArchivedCalleds', '');
        }
        // else if ((newOrderFilter != null && newOrderSearch != null && newOrderFilter.length == 0 && newOrderSearch.length == 0) && (newFilter != null && newSearch != null && newFilter.length == 0 && newSearch.length == 0)) {
        //     await this.getDefaultFilter()
        // }
    }

    handleChangeFieldValue = (value) => {
        const { intl } = this.props

        let returnAction = [
            {
                id: 1,
                name: intl.formatMessage({ id: "search" })
            }
        ]

        let twoActions = this.orderTwoActions.find(e => e === value)

        if (twoActions && twoActions.length > 0) {
            returnAction = [
                {
                    id: 1,
                    name: intl.formatMessage({ id: "search" })
                },
                {
                    id: 2,
                    name: intl.formatMessage({ id: "order" })
                }
            ]
        }

        return returnAction
    }

    handleChangeValue = (name, value) => {
        this.setState(prevState => ({
            ...prevState,
            [name]: value
        }))
    }

    addFilter = async (filter, value) => {
        const intl = this.props.intl

        if (value.trim() == '' && filter == 0) {
            this.setState({
                openNotification: true, notificationVariant: "error",
                notificationMessage: intl.formatMessage({ id: "caled.list.notification.select.one.filter.option" })
            });
        } else {
            let newFilter = localStorage.getItem('newFilterArchivedCalleds')
            let newSearch = localStorage.getItem('newSearchArchivedCalleds')

            if (value != '' && filter != 0) {
                if (filter === "open") {
                    let date = value.split("/");
                    if (date.length === 3) {
                        date = `${date[2]}-${date[1]}-${date[0]}`
                    }
                    newFilter += filter + "|";
                    newSearch += date + "|";

                    let nameField;
                    for (let i = 0; i < this.state.filters.length; i++) {

                        if (this.state.filters[i].id === filter) {
                            nameField = this.state.filters[i].name;
                        }
                    }

                    this.setState({
                        contentFilter: `${this.state.contentFilter}${nameField} = ${value}\n`
                    })

                } else {
                    if (newFilter == null) {
                        newFilter = ''
                    }
                    if (newSearch == null) {
                        newSearch = ''
                    }
                    newFilter += filter + "|"
                    newSearch += value + "|"

                    let nameField;
                    for (let i = 0; i < this.state.filters.length; i++) {
                        if (this.state.filters[i].id === filter) {
                            nameField = this.state.filters[i].name;
                        }
                    }

                    if (nameField == undefined && filter == "calledcards") {
                        nameField = intl.formatMessage({ id: "called.report.header" })
                    }

                    this.setState({
                        contentFilter: `${this.state.contentFilter}${nameField} = ${value}\n`
                    })
                }
                localStorage.setItem("newFilterArchivedCalleds", newFilter)
                localStorage.setItem("newSearchArchivedCalleds", newSearch)

                this.setState({ searchValue: '', filterSelected: 0 })
            }
        }
    }

    validateDateRange = () => {
        const { dateStart, dateEnd } = this.state
        const { intl } = this.props
        try {
            if (!dateStart || !dateEnd) {
                var message = intl.formatMessage({ id: "date.pickers.invalid.date" })
                this.setState({ alertType: "error", alertMessage: message })
                return { valid: false, message: message }
            }
            const startDateMoment = moment(dateStart, 'YYYY/MM/DD HH:mm:ss')
            const endDateMoment = moment(dateEnd, 'YYYY/MM/DD HH:mm:ss')
            const maxDateRange = startDateMoment.clone().add(6, 'months')

            var message = intl.formatMessage({ id: "general.search.max.period" })
            if (startDateMoment.isAfter(endDateMoment)) {
                message = intl.formatMessage({ id: "report.audit.initial.date.higher.than.end.date" })
                this.setState({ alertType: "error", alertMessage: message })
                return { valid: false, message: message }
            }
            if (endDateMoment.isAfter(maxDateRange)) {
                this.setState({ alertType: "error", alertMessage: message })
                return { valid: false, message: message }
            }
            if (startDateMoment.isAfter(moment())) {
                message = intl.formatMessage({ id: "called.time.entries.registration.date.field" })
                this.setState({ alertType: "error", alertMessage: message })
                return { valid: false, message: message }
            }
            this.setState({ alertType: "info", alertMessage: message })
            return { valid: true, message: "" }
        } catch (e) {
            return { valid: false, message: intl.formatMessage({ id: "date.pickers.invalid.date" }) }
        }
    }

    async getCalleds(page = 1) {

        const intl = this.props.intl
        this.emptySearchArchived = false
        this.emptySearchFinishCalleds = false
        this.emptySearchCanceledCalleds = false

        let url = `/archivedcalleds/paginate?page=${page}`

        let newFilter = localStorage.getItem('newFilterArchivedCalleds')
        let newSearch = localStorage.getItem('newSearchArchivedCalleds')

        let isSearchById = newFilter.includes('id')

        if (newFilter != '' && newSearch != '') {
            url += `&search=${newSearch}&field=${newFilter}`
            this.setState({ dataFilter: true })
        }

        const validateDate = this.validateDateRange()

        if (!validateDate.valid && !isSearchById) {
            this.setNotification("error", validateDate.message)
            return
        }

        const sqlDateStart = this.state.dateStart.toISOString()
        const sqlDateEnd = this.state.dateEnd.toISOString()
        url += `&dateStart=${encodeURIComponent(sqlDateStart)}&dateEnd=${encodeURIComponent(sqlDateEnd)}&dateOption=${this.state.dateOptionSelected.id}`
        var formattedList = null

        this.setState({ selectedColumnns: [], loading: true })

        await Api.get(url)
            .then(async result => {
                if (result.data.success) {
                    if (result.data.data.length === 0) {
                        if (page > 1) {
                            this.onChangePaginate(null, (page - 1))
                        }
                        this.setState({ emptySearchArchived: false, emptySearchFinishCalleds: false, emptySearchCanceled: false, emptyArray: true });
                    }
                    else {
                        this.setState({ emptySearchArchived: false, emptySearchFinishCalleds: false, emptySearchCanceled: false, emptyArray: false });
                    }

                    let count = result.data.count

                    PapiroConsole.log(result.data.data)
                    PapiroConsole.log("result.data.data CONSOLE AQUI")
                    formattedList = result.data.data
                    let selectedCols = []
                    formattedList = result.data.data.map(item => {
                        if (item && item.calledlistdata != null) {
                            let cols = this.calledListDataFormmat(item.calledlistdata)
                            selectedCols = this.arrayUnique(selectedCols.concat(cols))
                        }

                        return {
                            ...item,
                            actions: this.isClient ? null : <div style={{ display: 'flex', flexDirection: 'row' }}>
                                <IconButton
                                    size="small"
                                    onClick={() => this.goToCalled(item, true)}
                                >
                                    <CallMade />
                                </IconButton>

                            </div>,
                            onlyId: <LinkA component="button"
                                onClick={() => {
                                    let abl = this.context.can('Answer', 'Called');
                                    let abl2 = this.context.can('Edit', 'Called');
                                    if (abl == false && abl2 == false) {

                                        this.showMessage(true, 'error', intl.formatMessage({ id: "called.list.message.unallowed.task" }));
                                        return false;
                                    }
                                    this.goToCalled(item, false)
                                }
                                } variant="body2">
                                {item.id}
                            </LinkA>
                        }
                    })

                    var pagination = this.setPagination(count, page, 10)

                    await this.setState({
                        loading: false, count: count, calleds: formattedList, pageStart: pagination.pageStart, pageEnd: pagination.pageEnd, totalPages: pagination.totalPages, page: pagination.page
                    })
                    this.setCountLoading()
                } else {
                    this.setState({ openNotification: true, notificationVariant: 'error', })
                    Api.kickoff(result)
                    this.setCountLoading()
                }
            })
            .catch(err => {
                console.error(err)
                this.setState({
                    openNotification: true, notificationVariant: "error",
                    notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                })
                Api.kickoff(err)
                this.setCountLoading()
            })
            .finally(() => {
                this.setState({ loading: false })
            })
    }

    setCountLoading() {
        this.setState({ countLoading: this.state.countLoading + 1, })
        if (this.state.countLoading >= 1) {
            this.setState({
                loading: false,
            })
        }
    }

    clearFields = async () => {
        this.clearFilters()
        await this.setState({ loading: false })
    }

    clearFilters = async () => {
        localStorage.setItem('newFilterArchivedCalleds', '')
        localStorage.setItem('newSearchArchivedCalleds', '')
        localStorage.setItem('calledsPageArchivedCalleds', '1')
        await this.setState({ filterSelected: 0, searchValue: '', page: 1, contentFilter: '', contentOrder: '', loading: true })

    }

    callSearch = async (filter, value, type = 1) => {
        if ((value && value.trim() != '') && filter != 0) {
            await this.addFilter(filter, value, type)
        }
        if ((this.state.contentFilter && this.state.contentFilter.length > 0) || (this.state.contentOrder && this.state.contentOrder.length > 0)) {
            await this.getCalleds(this.state.page)
        }
    }

    closeNotification = () => {
        this.setState({ openNotification: false });
    }

    handleDelete(chipToDelete) {
        const intl = this.props.intl;
        let valueAtual = this.state.contentFilter.split("\n")
        let newvalue = "";
        let newFilter = ""
        let newSearch = ""
        valueAtual.map(item => {
            if (item != "" && item != valueAtual[chipToDelete]) {
                newvalue = newvalue + item + " \n"
                let itemSplit = item.split(" = ")

                if (itemSplit && itemSplit[0] && itemSplit[1]) {
                    let nameField = itemSplit[0]
                    let filterName = this.state.filters.filter(f => f.name === itemSplit[0])

                    if (filterName && filterName.length > 0) {
                        nameField = filterName[0].id
                    }
                    else if (nameField == intl.formatMessage({ id: "called.report.header" })) {
                        nameField = "calledcards"
                    }
                    newFilter += nameField + '|'
                    newSearch += itemSplit[1] + '|'
                }
            }
        })
        this.setState({
            contentFilter: newvalue
        })
        localStorage.setItem("newFilterArchivedCalleds", newFilter)
        localStorage.setItem("newSearchArchivedCalleds", newSearch)
    }

    setPagination = (count, page, pageCount) => {
        let result = {}
        let totalPage = Math.ceil(count / pageCount)
        if (count > 0) {
            if (page == 1) {
                if (count < pageCount) {
                    result.pageStart = 1
                    result.pageEnd = count
                } else {
                    result.pageStart = 1
                    result.pageEnd = pageCount;
                }
            } else {
                let pageStart = ((page - 1) * pageCount) + 1
                result.pageStart = pageStart
                if (count >= page * pageCount) {
                    result.pageEnd = page * pageCount
                } else {
                    result.pageEnd = page * pageCount
                }
            }
            result.totalPages = totalPage
            result.page = page
            result.count = count
            result.pageCount = pageCount

        } else {
            result.totalPages = 0
            result.page = 1
            result.count = 0
            result.pageStart = 0
            result.pageEnd = 0
            result.pageCount = pageCount
        }
        return result
    }

    goToCalled = async (rowData, newTab = false) => {

        this.setState({ loading: true })
        let newassigned = rowData.assigneduser;
        this.setState({ loading: true })
        if (rowData.assigneduser) {

            if (rowData.assigneduser.email == null || (rowData.assigneduser.email && (rowData.assigneduser.email.length === 0 || rowData.assigneduser.email.length === 'undefined'))) {

                newassigned.name = `${rowData.assigneduser.name}`
            } else {

                newassigned.name = `${rowData.assigneduser.name} - ${rowData.assigneduser.email}`
            }
        }

        rowData.assigneduser = newassigned

        // COMENTADO POIS FOI RETIRADO DA API OS INCLUDES, O REDUX VEM SEM NENHUM DADO DE INCLUDE, COM AS LINHAS COMENTADAS, A PAGINA DE EDICAO BUSCA TODOS OS DADOS
        await this.props.addCurrentCalled(rowData)
        await this.props.addCalled(rowData)
        await this.props.addAccompanimentsList([])
        await this.props.addAccompanimentsListInCalled([], rowData.id)
        if (!this.isClient && rowData.status.id == 3) { // validacao de rejeicao

            this.props.history.push(`/${this.props.match.params.lang}/called-rejection-edit`)
            //this.loading(false);
        } else {
            if (newTab == false) {
                this.props.history.push(`/${this.props.match.params.lang}/called-accompaniment/${rowData.id}`)
            } else {

                let urlRedirect = "/" + this.props.match.params.lang + "/called-accompaniment/" + rowData.id
                setTimeout(() => {
                    window.open(urlRedirect, "_blank")
                    this.setState({ loading: false })
                }, 1000)
            }
        }
    }

    openCanAssignCalledDialog = (rowData, newTab = false) => {
        if (this.isTechnical && !this.isClient && !this.isCoordenator && !this.isAdmOrg && !this.admGlobal && !this.isAdm && rowData && rowData.status && rowData.status.statustypeid && rowData.status.statustypeid == 1) {
            this.setState({
                canAssignCalledDialogOpen: true,
                canAssignCalledRowData: rowData,
                canAssignCalledNewTab: newTab
            })
        } else {
            this.goToCalled(rowData, newTab)
        }
    }

    consultCalled = async (calledId) => {

        this.setState({ loading: true });
        let response = await searchById(calledId);
        if (
            response != null &&
            response.success != null &&
            response.success &&
            response.data != null &&
            response.data
        ) {
            this.setState({ loading: false });
            this.props.history.push(
                `/${this.props.match.params.lang}/called-view/${calledId}`
            );
        } else {
            const intl = this.props.intl;
            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: "error",
                notificationMessage:
                    response &&
                        response.response &&
                        response.response.data &&
                        response.response.data.errors &&
                        response.response.data.errors[0]
                        ? response.response.data.errors[0]
                        : intl.formatMessage({ id: "process.error" }),
            });
            Api.kickoff(response);
        }
    }

    setNotification = (variant, message) => {
        this.setState({
            openNotification: true,
            notificationVariant: variant,
            notificationMessage: message
        })
    }

    setLoading = (loading) => {
        this.setState({ loading: loading })
    }

    onChangePaginate = async (e, page) => {
        this.setState({ page: page, countLoading: 0 })
        localStorage.setItem('calledsPageArchivedCalleds', `${page}`)
        await this.getCalleds(page)
    }

    handleClickExportToCSV = async () => {
        this.setState({ loading: true });
        var url = '/report/archived-calleds/excel'

        const sqlDateStart = this.state.dateStart.toISOString()
        const sqlDateEnd = this.state.dateEnd.toISOString()
        url += `?dateStart=${encodeURIComponent(sqlDateStart)}&dateEnd=${encodeURIComponent(sqlDateEnd)}&dateOption=${this.state.dateOptionSelected.id}`

        let newFilter = localStorage.getItem('newFilterArchivedCalleds')
        let newSearch = localStorage.getItem('newSearchArchivedCalleds')

        if (newFilter != '' && newSearch != '') {
            url += `&search=${newSearch}&field=${newFilter}`
            this.setState({ dataFilter: true })
        }

        await ApiReports.get(url)
            .then((response) => {
                if (response.data.success) {
                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: 'success',
                        notificationMessage: this.props.intl.formatMessage({ id: "report.sent" }) + " (" + this.props.userSession.user.email + ")",
                    });
                } else {
                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: 'error',
                        notificationMessage: response.data.errors && response.data.errors[0] ? response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
                    });
                }
            })
            .catch((error) => {
                this.setState({
                    loading: false,
                    openNotification: true,
                    notificationVariant: 'error',
                    notificationMessage: error.data && error.data.response && error.data.response.data && error.data.response.data.errors && error.data.response.data.errors[0] ? error.data.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
                })
            })

        const intl = this.props.intl;

        this.setState({ loading: false })
    }

    render() {
        const { classes, headerMenu, actionsHeaderMenu, intl, match, history } = this.props

        const openFilterMenu = Boolean(this.state.filterMenuAnchorEl)

        let newFilter = localStorage.getItem('newFilterArchivedCalleds')

        let isSearchById = (newFilter && newFilter.includes('id'))

        var link = `/${this.props.match.params.lang}/called-registration`
        if (this.isClient) {
            link = `/${this.props.match.params.lang}/called-registration-client`
        }

        if (Api == null) {
            var l = this.props.match.params.lang;
            document.location.href = `/${l}/unavailable`
        }

        return (

            <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
                <HeaderMenu />
                <main
                    className={clsx(classes.content, {
                        [classes.contentShift]: headerMenu.open,
                    }, classes.actionsContent, {
                        [classes.actionscontentShift]: actionsHeaderMenu.open,
                    })}
                >
                    <div className={classes.drawerHeader} />
                    <Container component='main' maxWidth={false} style={{ paddingLeft: 0, marginLeft: 0 }}>
                        <CssBaseline />

                        <Grid container spacing={6} >
                            <Grid item xs={12} sm={12}>
                                <Grid container pb={2} justifyContent="space-between">
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        size="large"
                                        className={classes.button}
                                        startIcon={<Add />}
                                        component={Link} {...{ to: link }}
                                    >
                                        {<FormattedMessage id="called.new" />}
                                    </Button>
                                    {!this.isClient &&
                                        <TreeDots items={this.state.itemsTree} />
                                    }
                                </Grid>
                                {(this.state.contentFilter || this.state.contentOrder) &&
                                    <Card className="background-title-search">
                                        <CardContent>
                                            <Grid container spacing={1} alignItems="flex-end">
                                                <Grid item xs={8} md={6}>
                                                    <Typography component={'span'} variant="h5">
                                                        {intl.formatMessage({ id: "filters" })}:
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <strong>
                                                        {this.state.contentFilter && this.state.contentFilter.length > 0 && this.state.contentFilter.split("\n").map((i, key) => {
                                                            if (i.trim() != "") {
                                                                return <Chip
                                                                    key={key}
                                                                    label={i}
                                                                    onDelete={() => this.handleDelete(key)}
                                                                    color="primary"
                                                                    variant="outlined"
                                                                />
                                                            }
                                                        })}
                                                        {this.state.contentOrder && this.state.contentOrder.length > 0 && this.state.contentOrder.split("\n").map((i, key) => {
                                                            if (i.trim() != "") {
                                                                return <Chip
                                                                    key={key}
                                                                    label={i}
                                                                    onDelete={() => this.handleOrderDelete(key)}
                                                                    color="primary"
                                                                    variant="outlined"
                                                                />
                                                            }
                                                        })}
                                                    </strong>
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                    </Card>
                                }
                                <Card className="background-title-search">
                                    <CardContent>
                                        <Grid container spacing={1} justify="space-between" alignItems="center" direction="row">
                                            <Grid item xs={12} sm={12} md={2} lg={2}>
                                                <Typography component={'span'} variant="h5">
                                                    {<FormattedMessage id="called.header" />}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={10} lg={10}>
                                                <Grid container spacing={1} direction="row" alignItems="center">
                                                    <SearchBar
                                                        field={this.state.filterSelected}
                                                        filterValue={this.state.searchValue}
                                                        filterName={"searchValue"}
                                                        filters={this.state.filters}
                                                        addFilterEdit={this.addFilter}
                                                        clearFieldsEdit={this.clearFields}
                                                        callSearch={this.callSearch}
                                                        orderFields={this.state.orderFields}
                                                        handleChangeFieldValue={this.handleChangeFieldValue}
                                                        dateStart={this.state.dateStart}
                                                        dateEnd={this.state.dateEnd}
                                                        dateOptions={this.state.dateOptions}
                                                        dateOptionSelected={this.state.dateOptionSelected}
                                                        handleChangeValue={this.handleChangeValue}
                                                        useDateLimit
                                                        disableDates={isSearchById}
                                                        {...this.props} />
                                                    <Grid item xs={1} sm={1} md={1} lg={1}>
                                                        <IconButton
                                                            color='primary'
                                                            aria-label='filters'
                                                            component='span'
                                                            id="filter-menu"
                                                            aria-controls={openFilterMenu ? 'filter-menu' : undefined}
                                                            aria-haspopup="true"
                                                            aria-expanded={openFilterMenu ? 'true' : undefined}
                                                            onClick={this.handleClickFilterMenu} >
                                                            <MoreVert />
                                                        </IconButton>
                                                        <Menu
                                                            id="filter-menu"
                                                            aria-labelledby="filter-menu"
                                                            anchorEl={this.state.filterMenuAnchorEl}
                                                            open={openFilterMenu}
                                                            onClose={this.handleCloseFilterMenu}
                                                            anchorOrigin={{
                                                                vertical: 'top',
                                                                horizontal: 'left'
                                                            }}
                                                            transformOrigin={{
                                                                vertical: 'top',
                                                                horizontal: 'left'
                                                            }} >
                                                            <MenuItem onClick={this.handleClickExportToCSV} >
                                                                <ListItemIcon style={{ minWidth: 25 }}>
                                                                    <ExitToApp style={{ fontColor: "#3f51b4", fill: "#3f51b4" }} />
                                                                </ListItemIcon>
                                                                {intl.formatMessage({ id: "called.list.export" })}
                                                            </MenuItem>
                                                        </Menu>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                        <div className='material-table'>
                            {/*tableList()*/}
                            <Grid container spacing={0}>
                                {this.state.calleds.map((called) => {
                                    return <CalledCard
                                        archived={true}
                                        called={called}
                                        isAdm={this.isAdm}
                                        isClient={this.isClient}
                                        intl={intl}
                                        history={history}
                                        lang={match.params.lang}
                                        setNotification={this.setNotification}
                                        setLoading={this.setLoading}
                                    />
                                })}
                            </Grid>
                        </div>

                        {
                            (this.state.calleds.length == 0 && !this.state.contentFilter && !this.state.contentOrder) ?
                                <div>
                                    <FirstElement
                                        title={intl.formatMessage({ id: "archived.calleds" })}
                                        subtitle={intl.formatMessage({ id: "need.search" })}

                                        link={link}
                                        icon={<QueuePlayNext style={{ fontSize: "45px" }} />}
                                    />

                                </div>
                                :
                                <Grid container style={{ marginBottom: 12, marginTop: 8 }}>
                                    <Grid item xs={12} md={4}>
                                        <Pagination
                                            count={this.state.totalPages}
                                            page={this.state.page}
                                            onChange={this.onChangePaginate}
                                            showFirstButton
                                            showLastButton />
                                    </Grid>
                                    <Grid item xs={12} sm={3} style={{ marginTop: 6 }}>
                                        {this.state.pageStart} {<FormattedMessage id="to" />} {this.state.pageEnd} {<FormattedMessage id="of" />} {this.state.count} {<FormattedMessage id="register" />}
                                    </Grid>
                                </Grid>
                        }

                        {this.state.loading && (
                            <Overlay>
                                <CircularProgress color="secondary" />
                            </Overlay>
                        )}

                        <CustomizedSnackbars
                            variant={this.state.notificationVariant}
                            message={this.state.notificationMessage}
                            isOpen={this.state.openNotification}
                            toClose={this.closeNotification}
                        />
                    </Container>
                </main>
                <Footer organizations={this.userOrganizations} />
            </div>
        )
    }
}

CalledsArchived.propTypes = {
    classes: PropTypes.object.isRequired,
}

const mapStateToProps = state => ({
    lastCalledsQueue: state.lastCalledsQueue,
    actionsHeaderMenu: state.actionsHeaderMenu,
    headerMenu: state.headerMenu,
    userSession: state.userSession
})

const mapDispatchToProps = dispatch =>
    bindActionCreators(Object.assign({}, calledsActions, headerMenuActions, lastCalledsQueueActions, userSessionActions), dispatch)

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(CalledsArchived)))
CalledsArchived.contextType = AbilityContext
